import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import RegularButton from "../CustomButtons/Button.jsx";

export default function CustomDialog({ openDialog, closeDialog }) {
  return (
    <Dialog
      open={openDialog}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>There's no data available to export.</DialogTitle>
      <DialogActions>
        <RegularButton 
          onClick={closeDialog}
          color="success">
            Ok
        </RegularButton>
      </DialogActions>
    </Dialog>
  )
}
